export class DtoCoVendedor {
    vendedor: number;
    vendedorNombre: string;
}
